import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function ManageFloor() {
    const [floors, setFloors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [floorID, setFloorID] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [editData, setEditData] = useState({ floor: "" });

    const columns = [
        { name: "S.No.", selector: (row) => row.sln, sortable: true },
        { name: "Floor", selector: (row) => row.floor, sortable: true },
        {
            name: "Action",
            cell: (row) => (
                <>
                    <span title="Edit" onClick={() => handleEdit(row)}>
                        <i
                            className="fa-solid fa-pen-to-square"
                            style={{
                                cursor: "pointer",
                                padding: "5px",
                                marginRight: "5px",
                                fontSize: "1.5em",
                                color: "#477DA5",
                                backgroundColor: "#E9F3F7",
                            }}
                        ></i>
                    </span>
                    <span title="Delete" onClick={() => handleDelete(row.id)}>
                        <i
                            className="fa-solid fa-trash-can"
                            style={{
                                cursor: "pointer",
                                padding: "5px",
                                marginRight: "5px",
                                fontSize: "1.5em",
                                color: "#477DA5",
                                backgroundColor: "#E9F3F7",
                            }}
                        ></i>
                    </span>
                </>
            ),
        },
    ];

    const fetchAllFloors = async () => {
        setLoading(true);
        try {
            const res = await HomeService.getFloors();
            const arr = res?.data?.map((ele, ind) => ({
                sln: ind + 1,
                floor: ele.floor,
                id: ele._id,
            }));
            setFloors(arr);
        } catch (error) {
            console.error("Error fetching floors:", error);
            toast.error("Failed to load floors!");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllFloors();
    }, []);

    const handleEdit = (row) => {
        setIsEdit(true);
        setEditData({ floor: row.floor });
        setFloorID(row.id);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete Floor?",
            text: "Are you sure you want to delete this floor?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            confirmButtonColor: "#d33",
            cancelButtonText: "Cancel",
            reverseButtons: true,
        });
        if (result.isConfirmed) {
            try {
                await HomeService.deleteFloor(id);
                Swal.fire("Deleted!", "Floor has been deleted.", "success");
                fetchAllFloors();
            } catch (error) {
                Swal.fire("Error!", "Failed to delete floor.", "error");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = { floor: editData.floor };
            if (isEdit) {
                await HomeService.updateFloor(floorID, data);
                toast.success("Floor updated successfully!");
            }
            setIsEdit(false);
            setEditData({ floor: "" });
            fetchAllFloors();
        } catch (error) {
            toast.error("Failed to save floor.");
            console.error("Error saving floor:", error);
        }
    };

    return (
        <>
            <div className="main_wrap" style={{ marginTop: "6rem" }}>
                <div className="container-fluid">
                    {isEdit && (
                        <section className="chartBox_area">
                            <h2>Edit Floor</h2>
                            <hr />
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="floor">
                                            Floor<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="floor"
                                            className="form-control"
                                            value={editData.floor}
                                            onChange={(e) =>
                                                setEditData({ ...editData, floor: e.target.value })
                                            }
                                            placeholder="Enter Floor"
                                            required
                                        />
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary mt-3">
                                    Save Changes
                                </button>
                            </form>
                        </section>
                    )}

                    <div className="mt-5">
                        <div style={headLineStyle} className="page-headline">
                            Manage Floors
                        </div>
                        {loading ? (
                            <p>Loading...</p>
                        ) : (
                            <DataTable
                                columns={columns}
                                data={floors}
                                pagination
                                responsive
                                highlightOnHover
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManageFloor;
